import React from 'react';
import { observer } from 'mobx-react-lite';

import { SingleSelectDropdown } from '../../../components/select-dropdown';
import { MovieIcon } from '../../../components/icons/MovieIcon';
import { context } from '../../../app/context';
import { TaskPropertyButton } from './task-property.button';

type TaskProjectSelectorProps = {
  onChange: (value: string) => void;
  selectedProjectId: string | undefined;
  triggerVariant?: 'default' | 'minimal';
  isViewOnly?: boolean;
};

export const TaskProjectSelector: React.FC<TaskProjectSelectorProps> = observer(
  ({ onChange, selectedProjectId, isViewOnly = false, triggerVariant = 'default' }) => {
    const space = context.space;

    const options: React.ComponentProps<typeof SingleSelectDropdown>['options'] =
      space?.projects?.map((project) => ({
        label: project.name,
        value: project._id,
      })) || [];

    const handleProjectChange = (value?: string) => {
      // @ts-ignore
      onChange(value || null);
    };

    return (
      <SingleSelectDropdown
        trigger={(label) => (
          <div>
            {label ? (
              <TaskPropertyButton
                icon={
                  triggerVariant !== 'minimal' && (
                    <MovieIcon fill={isViewOnly ? 'var(--color-grayscale-shuttle)' : undefined} />
                  )
                }
                label={label}
                isActive
              />
            ) : (
              <TaskPropertyButton icon={<MovieIcon />} label="Select project" />
            )}
          </div>
        )}
        title="Project"
        value={selectedProjectId}
        placeholder="Search"
        options={options}
        onValueChange={handleProjectChange}
        disabled={isViewOnly}
        align={triggerVariant === 'minimal' ? 'end' : 'start'}
      />
    );
  },
);
